import React from 'react'
import { Row } from 'reactstrap'
import { StyledTitle } from './App'
import styled from 'styled-components'
import ReactSVG from 'react-svg'

const person = require('../assets/images/person.svg')
const paper = require('../assets/images/paper.svg')
const tools = require('../assets/images/tools.svg')
const clock = require('../assets/images/clock.svg')

const Services = () => {
  return (
    <div className='py-5 p-md-5' style={{ backgroundColor: '#F2F2F2' }}>
      <div className='container d-flex flex-wrap'>
        <div className='col-md-12'>
          <StyledTitle align='center' className='mb-5'>
              PORQUE ELEGIRNOS
          </StyledTitle>
          <br />
        </div>
        <div className='col-md-3 d-flex flex-wrap align-items-center justify-content-center'>
          <div className='text-center mb-4'>
            <ReactSVG path={person} svgStyle={{ width: 50, height: 50 }} />
          </div>
          <TextContent>
          Cada uno de nuestros asesores está especializado en el trámite que usted desea realizar, para así ayudar y completar de la manera más eficiente y rápida sus trámites.
          </TextContent>
        </div>
        <div className='col-md-3 d-flex flex-wrap align-items-center justify-content-center'>
          <div className='text-center mb-4'>
            <ReactSVG path={paper} svgStyle={{width: 50, height: 50}} />
          </div>
          <TextContent>
          Tiempo es dinero! No pierda el suyo buscando tutoriales, abriendo docenas de pestañas para poder hacer un tramite, lo hace en 5 min en nuestros forms simplificados y se los entregamos en el día!.
          </TextContent>
        </div>
        <div className='col-md-3 d-flex flex-wrap align-items-center justify-content-center'>
          <div className='text-center mb-4'>
            <ReactSVG path={clock} svgStyle={{width: 50, height: 50}} />
          </div>
          <TextContent>
          Puede completar sus datos 24/7, y ante cualquier duda nuestros asesores estarán a su disposición para ayudarlos a despejar sus miedos y brindar seguridad para completar sus formularios.
          </TextContent>
        </div>
        <div className='col-md-3 d-flex flex-wrap align-items-center justify-content-center'>
          <div className='text-center mb-4'>
            <ReactSVG path={tools} svgStyle={{width: 50, height: 50}} />
          </div>
          <TextContent>
          Todos los datos que usted nos brindan voluntariamente, se encuentran encriptados en nuestra base de datos, y los mismos son borrados automáticamente luego de un breve periodo de tiempo, para su seguridad.</TextContent>
        </div>
      </div>
    </div>
  )
}

const TextContent = styled.p`
  font-family: 'Montserrat';
  font-size: 15px;
  text-align: justify;
  padding-left: 20px;
  padding-right: 20px;
  min-height: 200px;
`

export default Services
